/**
 * Converts a string to a URL-friendly slug.
 * - Normalizes Unicode (NFD decomposition to separate base chars from diacritics)
 * - Strips diacritic combining marks
 * - Lowercases
 * - Replaces spaces and non-alphanumeric characters with hyphens
 * - Collapses consecutive hyphens
 * - Trims leading/trailing hyphens
 */
export function slugify(text) {
    return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
